import { Link, ModulePage, PDP_SSR_Data } from '~/lib';

export interface ProductCategoryLinks {
    brand: Link | null;
    category: Link | null;
    series: Link | null;
    subCategory: Link | null;
}

export type ProductDetailsPageProps = ModulePage & {
    type: 'p50ProductDetailsPage';
    data: PDP_SSR_Data;
    productCategoryLinks: ProductCategoryLinks;
};

/**
 * `exact` keeps every currently selected attribute; `closest` only keeps the picked one,
 * so others may change; `none` means nothing carries the value and it is not navigable.
 */
export type VariantMatchQuality = 'exact' | 'closest' | 'none';

export interface VariantOption {
    value: string;
    label: string;
    productId?: string;
    href?: string;
    imageUrl?: string;
    price?: number;
    isOrderable: boolean;
    isSelected: boolean;
    matchQuality: VariantMatchQuality;
}

export interface VariantGroup {
    id: string;
    name?: string;
    selectedValue?: string;
    options: VariantOption[];
}

export interface ProductInfoLabelDialogContent {
    src: string;
    alt?: string;
    label: string;
    closeLabel: string;
}

export enum ProductTab {
    DESCRIPTION = 'product-description',
    SPECIFICATIONS = 'specifications',
    DOCUMENTATION = 'documentation',
}
